export const DialogStyle = {
  errorMessage: {
    style: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '16px',
    },
    sx: {
      color: 'text.secondary',
    },
  },
  brokenImage: {
    width: '15px',
    marginRight: '14px',
  },
};
